import { useEffect, useState } from 'react';
import useRootAppStore from './use-root-app-store';
const useCheckPoolingRoutes = (enabledPaths) => {
    const [match, setMatch] = useState(false);
    const { router } = useRootAppStore();
    const { currentPath } = router;
    useEffect(() => {
        const found = !!enabledPaths.find((e) => currentPath.startsWith(e));
        if (found && match === false) {
            setMatch(true);
        }
        else if (!found && match === true) {
            setMatch(false);
        }
    }, [currentPath]);
    return match;
};
export default useCheckPoolingRoutes;
//# sourceMappingURL=use-check-pooling-routes.js.map